export default __webpack_public_path__ + "static/media/fondopadel8.38067669.jpg";